<template>
  <Modal
    class="create-update-modal"
    :mask-closable="false"
    :closable="false"
    :title="actionText + '代理商'"
    v-model="modal">
    <Form ref="handleForm" :model="handleForm" :rules="handleValidate" :label-width="110">
      <Row>
        <Col :sm="24" :xs="24">
          <FormItem label="代理商名称:" prop="agentId">
            <Select v-model="handleForm.agentId" style="width: 100%;">
              <Option v-for="item in commoditiesList" :value="item.id" :key="item.id">{{ item.agentName }}</Option>
            </Select>
          </FormItem>
        </Col>
        <Col :sm="24" :xs="24">
          <Row>
            <Col span="10">
              <FormItem label="订购元素类型:">
                <Select v-model="handleForm.elementType">
                  <Option v-for="item in OfferType" :value="item.value" :key="item.value">{{ item.label }}</Option>
                </Select>
              </FormItem>
            </Col>
            <Col span="14">
              <FormItem label="产品ID:" prop="offerId">
                <Input v-model.trim="handleForm.offerId" placeholder="请输入" maxlength="10"/>
              </FormItem>
            </Col>
          </Row>
        </Col>
<!--        <Col :sm="24" :xs="24">-->
<!--          <FormItem label="产品ID:" prop="agentId">-->
<!--            <Input v-model.trim="handleForm.offerId" placeholder="请输入" maxlength="100" show-word-limit/>-->
<!--          </FormItem>-->
<!--        </Col>-->
        <Col :sm="24" :xs="24">
          <FormItem label="订购类型:" prop="modifyTag">
            <Select v-model="handleForm.modifyTag" clearable style="width: 100%;">
              <Option value="0">订购</Option>
              <Option value="1">删除</Option>
            </Select>
          </FormItem>
        </Col>
        <Col :sm="24" :xs="24">
          <FormItem label="绑定商品:" prop="bindGoodId">
            <Select
              v-model.trim="commoditiesIndex"
              placeholder="请选择或输入查询"
              filterable
              clearable
              remote
              @on-change="commodityQueryChange"
              @on-select="selectCommodity"
              @on-clear="clearCommodity">
              <Option v-for="(option, index) in commodityOptions" :value="index" :key="option.value">{{option.label}}</Option>
            </Select>
          </FormItem>
        </Col>
      </Row>
    </Form>
    <div slot="footer">
      <Button type="text" @click="hide" :disabled="loading">取消</Button>
      <Button type="primary" :loading="loading" @click="submit">确定</Button>
    </div>
  </Modal>
</template>

<script>
import api from '@/api'

const OfferType = [
  { label: 'D 优惠', value: 'D' },
  { label: 'S 服务', value: 'S' },
  { label: 'Z 平台服务', value: 'Z' },
  { label: 'P 产品', value: 'P' }
]

export default {
  name: 'AgentApiCreateUpdate',
  data () {
    return {
      commodityOptions: [],
      OfferType,
      modal: false,
      loading: false,
      action: 'create',
      dataIndex: null,
      commoditiesIndex: null,
      commoditiesList: [], // 代理商列表
      reqUrlList: [], // 接口列表
      handleForm: {
        offerId: '',
        agentId: '',
        elementType: 'D',
        modifyTag: '0',
        bindGoodId: '',
        bindGoodName: '',
      },
      handleValidate: {
        offerId: [
          { required: true, whitespace: true, message: '请输入产品ID', trigger: 'change' }
        ],
        reqUrl: [
          { required: true, whitespace: true, message: '请选择接口地址', trigger: 'change' }
        ]
      }
    }
  },
  computed: {
    actionText () {
      return this.action === 'create' ? '新增' : '编辑'
    }
  },
  methods: {
    // 代理商列表
    getAgentCommoditiesList () {
      api.agent.queryAgentCommodities({}).then((res) => {
        this.commoditiesList = res.data || []
      })
    },
    show (action = 'create', data = {}, index) {
      // 代理商列表
      this.getAgentCommoditiesList()
      this.action = action
      if (this.action === 'update') {
        this.handleForm = {
          id: data.id,
          agentId: data.agentId,
          agentName: data.agentName,
          elementType: data.elementType,
          status: data.status,
          offerId: data.offerId,
          modifyTag: data.modifyTag,
          bindGoodId: data.bindGoodId,
          bindGoodName: data.bindGoodName
        }
        this.dataIndex = index
      }
      this.modal = true
      this.commodityQuery()
    },
    // 清除
    clearCommodity () {
      this.handleForm.bindGoodName = ''
    },
    commodityQuery () {
      this.commodityLoading = true
      api.commodity.commodityList({
        pageNum: 1,
        pageSize: 999,
        commodityName: this.queryCommodity,
        sourceType: 0,
        useState: 1
      }).then(res => {
        const result = res.data.records || []
        this.commodityOptions = []
        let i=0;
        result.map(item => {
          this.commodityOptions.push({
            value: item.id,
            label: item.commodityName + '(' + item.labelName + ')',
            name: item.commodityName
          })
          if(this.action === 'update') {
            if(item.id === this.handleForm.bindGoodId) {
              this.commoditiesIndex = i
            }
          }
          i++;
        })
      }).catch(() => {
        // tips
        this.commodityOptions = []
      }).then(() => {
        this.commodityLoading = false
      })
    },
    commodityQueryChange (item) {
      console.log(item)
      let option = this.commodityOptions[item];
      if (option) {
        this.handleForm.bindGoodId=option.value;
        this.handleForm.bindGoodName=option.name;
      }else {
        this.handleForm.bindGoodId='';
        this.handleForm.bindGoodName='';
      }
    },
    // 选中
    selectCommodity (val) {
      this.queryCommodity = val.value
      this.isSelectCommodity = true
      this.isClearCommodity = false
    },
    hide () {
      this.$refs['handleForm'].resetFields()
      this.handleForm.agentId = ''
      this.dataIndex = null
      this.loading = false
      this.modal = false
    },
    submit () {
      this.$refs['handleForm'].validate((valid) => {
        if (valid) {
          this.submitForm()
        } else {
          this.$Message.error('请填写必填项目!')
        }
      })
    },
    submitForm () {
      let queryParams = {
        ...this.handleForm
      }
      const filterData = this.commoditiesList.filter(item => item.id === queryParams.agentId)
      if (filterData && filterData.length > 0) {
        queryParams.agentName = filterData[0].agentName
      }
      queryParams.status = '2'
      const filterDataUrl = this.reqUrlList.filter(item => item.url === queryParams.reqUrl)
      if (filterDataUrl && filterDataUrl.length > 0) {
        queryParams.reqName = filterDataUrl[0].name
      }
      let submitApi = api.supplier.supplierCommodityCreate
      if (this.action === 'update') {
        submitApi = api.supplier.supplierCommodityUpdate
      }
      this.loading = true
      submitApi(queryParams).then(res => {
        this.$emit('success', this.action, {
          ...queryParams
        }, this.dataIndex)
        this.$Message.success(this.actionText + '成功！')
        this.hide()
      }).catch(err => {
        this.$Message.error(this.actionText + '失败：' + err.message)
      }).then(() => {
        this.loading = false
      })
    }
  }
}
</script>
